<template>
  <div class="card">
    <h5 class="card-header">{{ $t('Feature.CensusResults.age_groups') }}</h5>
    <div class="card-body">
      <svg class="agegroup-vis" height="300" width="100%">
        <g id="left-axis" class="agegroup-vis__left-axis" transform="translate(25,5)"></g>
        <g id="bottom-axis" class="agegroup-vis__bottom-axis" :transform="`translate(${25+xScale.paddingInner()}, 275)`">
          <g
            v-for="(tick, index) in xLabels"
            v-bind:key="index"
            :transform="`translate(${index * xScale.step()} ,0)`"
            class="tick">
            <line y2="6"></line>
            <text y="9" dy="0.71em">{{tick}}</text>
          </g>
        </g>
        <g transform="translate(25,5)">
          <g
            class="agegroup-vis__bar"
            v-for="item in queryData"
            v-bind:key="item.code"
            :transform="`translate(${xScale(item.code)},0)`">
            <rect
              class="bar__background"
              :width="xScale.bandwidth()"
              height="270">
            </rect>
            <rect
              class="bar__value"
              :width="xScale.bandwidth() - 2"
              :height="270 - yScale(item.count)"
              :y="yScale(item.count)"
              x="1">
            </rect>
            <title>{{$t(`Enums.age_groups.${item.code}`)}}: {{$n(item.count)}}</title>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { axisLeft, axisBottom } from "d3-axis";
import { format } from "d3-format";
import { scaleBand, scaleLinear } from "d3-scale";
import { select } from "d3-selection";

const xDomain = [
  "AGE0TO4", "AGE5TO9", "AGE10TO14", "AGE15TO19", "AGE20TO24", "AGE25TO29",
  "AGE30TO34", "AGE35TO39", "AGE40TO44", "AGE45TO49", "AGE50TO54", "AGE55TO59",
  "AGE60TO64", "AGE65TO69", "AGE70TO74", "AGE75TO79", "AGE80TO84", "AGE85OVER",
]

export default {
  props: ["queryData"],
  data(){
    return {
      svgWidth: 300,
      xLabels: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, "+"]
    }
  },
  computed: {
    xScale() {
      return scaleBand()
        .rangeRound([0, this.svgWidth - 25])
        .padding(0)
        .align(0)
        .domain(xDomain);
    },
    yScale() {
      return scaleLinear()
        .range([270, 0])
        .domain([0, Math.max(...this.queryData.map(item => item.count))])
        .nice();
    },
    xAxis() {
      return axisBottom(this.xScale)
        .tickFormat(d => d.replace(/^(\d*).*/, "$1"));
    },
    yAxis() {
      return axisLeft(this.yScale)
        .tickFormat(format("~s"));
    }
  },
  mounted(){
    this.updateAxis();
  },
  updated(){
    this.updateAxis();
  },
  methods:{
    updateAxis() {
      this.svgWidth = this.$el.querySelector("svg.agegroup-vis").clientWidth;

      const leftAxis = this.$el.querySelector("#left-axis");

      select(leftAxis).call(this.yAxis);
    }
  }
}
</script>

<style lang="scss">
.agegroup-vis__bar {
  .bar__background {
    fill-opacity: 0;
  }

  .bar__value {
    fill: #3c5a7f;
    fill-opacity: 0.5;
  }

  &:hover .bar__value {
    fill-opacity: 1;
  }
}

.agegroup-vis__left-axis,
.agegroup-vis__bottom-axis {
  path.domain {
    fill: none;
    stroke: none;
  }

  g.tick {
    line {
      stroke: #e5e5e5;
    }

    text {
      font-size: 8px;
      text-anchor: middle;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Visuals/AgeGroups.vue